import { setGeometry } from '../../api/Missions/mission-methods-client';
import * as missionOps from '../../api/Missions/mission-operations';

const ATLAS_TYPE = 'atlas';
const MAPS_TYPE = 'leafletMap';
const MISSION_TYPE = 'mission';
const PRECISION = 15;
const VIDEO_TYPE = 'video';

/**
 * Gets the geometry from the event fired (creation) and saves it to database. Also update draw controls accordingly.
 *
 * @callback
 * @param {*} arg - The object argument.
 * @param {object} arg.event - The event fired after creating a geometry.
 * @param {Function} arg.getCurrentMapState - A function that gets the current variables needed from the map component.
 */
const saveGeometry = ({ event, getCurrentMapState }) => {
  const {
    defineGeometryActive,
    drawControl,
    editControl,
    itemType,
    leafletMap,
    mission,
    setVideoGeometry,
    setAtlasGeometry
  } = getCurrentMapState();

  const featureFromLayer = event.layer.toGeoJSON(PRECISION);

  leafletMap.removeControl(drawControl);
  leafletMap.addControl(editControl);

  if (itemType === MISSION_TYPE && defineGeometryActive) {
    // TODO: add alert to redraw misison
    setGeometry(missionOps.getId(mission), featureFromLayer);
  }

  if (itemType === VIDEO_TYPE && defineGeometryActive) {
    setVideoGeometry(featureFromLayer, true);
  }

  if ((itemType === ATLAS_TYPE || itemType === MAPS_TYPE) && defineGeometryActive) {
    setAtlasGeometry(featureFromLayer);
  }
};

export default saveGeometry;
